import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="py-10 bg-[#1a1a2e] text-center relative overflow-hidden" data-id="element-59">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-60"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-62">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-3 font-montserrat" data-id="element-63">
            El momento de empezar es ahora
          </h2>
          <p className="text-xl text-gray-300 mb-6" data-id="element-64">
            Cada día es una oportunidad para mejorar la dinámica familiar.{' '}
            <br className="hidden md:block" data-id="element-65" />
            Empieza con un plan claro y probado.
          </p>

          <Button variant="secondary" size="xl" className="w-full sm:w-auto px-12 py-6 text-lg" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-66">
            Descargar El Interruptor Digital Ahora
          </Button>
        </motion.div>
      </div>
    </section>;
}